class WishlistProduct extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", this.onAddWishlist.bind(this));
    this.LOCAL_STORAGE_WISHLIST_KEY = "shopify-wishlist";
    this.LOCAL_STORAGE_DELIMITER = ",";
    this.BUTTON_ACTIVE_CLASS = "active";
    this.onAddActiveClass();
    this.WishlistItemCounter();
  }

  WishlistItemCounter() {
    const WISHLIST_ITEM_COUNT = document.querySelectorAll(".wishlist__count");
    const wishlist_item_length = this.getWishlist().length;

    WISHLIST_ITEM_COUNT.forEach((singleItem) => {
      singleItem.innerText = wishlist_item_length; // Show 0 when no items are in the wishlist
    });
  }

  onAddActiveClass() {
    const wishlistAddedButton = this.querySelector("button");
    if (wishlistAddedButton != null) {
      const productHandle = wishlistAddedButton.dataset.productHandle || false;
      if (!productHandle) {
        console.error(
          "[Wishlist] Missing `data-product-handle` attribute. Failed to update the wishlist."
        );
        return;
      }
      if (this.wishlistContains(productHandle)) {
        wishlistAddedButton.classList.add(this.BUTTON_ACTIVE_CLASS);
      }
    }
  }

  onAddWishlist() {
    const wishlistItem = this.querySelector("button");
    const productHandle = wishlistItem.dataset.productHandle || false;

    if (!productHandle) {
      console.error(
        "[Wishlist] Missing `data-product-handle` attribute. Failed to update the wishlist."
      );
      return;
    }

    this.updateWishlist(productHandle);
    this.WishlistItemCounter();

    const grid = document.querySelector("[grid-wishlist]") || false;

    if (grid) {
      this.closest(".product__card").remove();
    } else {
      wishlistItem.classList.add("loading", "adding");
      setTimeout(() => {
        wishlistItem.classList.remove("loading");
        wishlistItem.classList.toggle("active");
      }, 500);

      setTimeout(() => {
        const addingElement = document.querySelector(".adding");
        if (addingElement) {
          addingElement.classList.remove("adding");
        }
      }, 1000);
    }

    const wishlist_item_length = this.getWishlist().length;

    if (wishlist_item_length === 0 && grid) {
      grid.parentElement.classList.remove("wishlist_exists");
    }
  }

  getWishlist() {
    const wishlist =
      localStorage.getItem(this.LOCAL_STORAGE_WISHLIST_KEY) || "";
    return wishlist ? wishlist.split(this.LOCAL_STORAGE_DELIMITER) : [];
  }

  setWishlist(array) {
    const wishlist = array.join(this.LOCAL_STORAGE_DELIMITER);
    if (array.length) {
      localStorage.setItem(this.LOCAL_STORAGE_WISHLIST_KEY, wishlist);
    } else {
      localStorage.removeItem(this.LOCAL_STORAGE_WISHLIST_KEY);
    }
    return wishlist;
  }

  updateWishlist(handle) {
    const wishlist = this.getWishlist();
    const indexInWishlist = wishlist.indexOf(handle);

    if (indexInWishlist === -1) {
      wishlist.push(handle);
    } else {
      wishlist.splice(indexInWishlist, 1);
    }

    return this.setWishlist(wishlist);
  }

  wishlistContains(handle) {
    const wishlist = this.getWishlist();
    return wishlist.includes(handle);
  }
}
customElements.define("wishlist-item", WishlistProduct);

const newWishlistObj = new WishlistProduct();

document.addEventListener("DOMContentLoaded", function () {
  const grid = document.querySelector("[grid-wishlist]") || false;
  if (grid) {
    setupGrid(grid);
  }
});

const setupGrid = function (grid) {
  const wishlist = newWishlistObj.getWishlist();
  const wihslitExistBtn = document.querySelector(".wishlist-page");

  if (wishlist.length >= 0) {
    wihslitExistBtn.classList.add("wishlist_exists");
  } else {
    wihslitExistBtn.classList.remove("wishlist_exists");
  }

  const requests = wishlist.map((handle) => {
    const productTileTemplateUrl = `/products/${handle}?view=wishlist`;
    return fetch(productTileTemplateUrl).then((res) => {
      if (res.status === 200) {
        return res.text();
      }
    });
  });

  Promise.all(requests).then((responses) => {
    const wishlistProductCards = responses.join("");
    grid.innerHTML = wishlistProductCards;
    const buttons = grid.querySelectorAll("wishlist-item") || [];
  });
};
